// Mock data for K-Root — original commercial copywriting (v2)

export const PRODUCT = {
  id: 'korean-scalp-revival-bar',
  handle: 'korean-scalp-revival-bar',
  title: 'Korean Scalp Revival Bar',
  rating: 4.7,
  reviewCount: 10619,
  price: 24.99,
  compareAtPrice: 50,
  badge: 'Save 50%',
  images: [
    'https://customer-assets.emergentagent.com/job_content-135/artifacts/2nugxjhr_db9dytor_K-Root_logo_diagonal-REPLACE.jpg%20%281%29.png',
    'https://customer-assets.emergentagent.com/job_content-135/artifacts/yjjgu6bw_hf_20260304_231205_6639372a-e297-468a-ba19-960627c2b9b6-REPLACE.jpg.png',
    'https://customer-assets.emergentagent.com/job_content-135/artifacts/tddsadva_hf_20260304_231647_df9ee040-8ad4-42f5-9cf9-ac3042c0e103-REPLACE.jpg.png',
    'https://yoracare.com/cdn/shop/files/hf_20260304_231941_62af97bc-a2c8-4326-ae30-397099e13fc8.webp?v=1772669289&width=1200',
    'https://customer-assets.emergentagent.com/job_content-135/artifacts/ok8g92pr_hf_20260304_232232_98951d7d-05ee-4281-8c02-205c49f0a997-REPLACE.jpg.png',
    'https://customer-assets.emergentagent.com/job_content-135/artifacts/6eyacb3v_hf_20260304_232919_780a0cce-e52e-48b1-9635-ae2c13b57b52-REPLACE.jpg.png',
    'https://customer-assets.emergentagent.com/job_content-135/artifacts/3obeka1u_hf_20260310_060215_08570396-767c-4646-814e-d922197e4956-REPLACE.jpg.png',
    'https://customer-assets.emergentagent.com/job_content-135/artifacts/1xi4u09d_hf_20260304_233446_0f5d1f2a-759c-4acd-8bef-ebdcfae0e33d-REPLACE.jpg.png',
  ],
  shortDescription: 'The 60-second Korean scalp protocol that ends the morning panic. While shampoo feeds your hair, this revives the soil beneath it — so the strands you have left finally stop falling, and the ones you lost finally come back.',
  features: [
    '12 Fermented Herbs',
    'Vegan & Cruelty-Free',
    'Sulfate-Free',
    'Dermatologist approved',
  ],
  // Fallback bundles for first paint before /api/bundles loads.
  bundles: [
    {
      id: 'b1',
      label: 'Buy 1 Get 1 Free',
      bars: '2 Bars',
      duration: '60-Day Supply',
      price: 49.99,
      currency: 'USD',
      symbol: '$',
      tag: null,
      is_hero: true,
      tax_inclusive: false,
      image: 'https://cdn.shopify.com/s/files/1/0801/3994/4187/files/1780818378Rapi-Bundles-Duo_TP_300x300.png?v=1780818381',
    },
    {
      id: 'b2',
      label: 'Buy 2 Get 2 Free',
      bars: '4 Bars',
      duration: '120-Day Ritual',
      price: 79.99,
      currency: 'USD',
      symbol: '$',
      tag: 'MOST POPULAR',
      is_hero: false,
      tax_inclusive: false,
      image: 'https://cdn.shopify.com/s/files/1/0801/3994/4187/files/1780818390Rapi-Bundles-Quatuor_Tp_300x300.png?v=1780818393',
    },
    {
      id: 'b3',
      label: 'Buy 3 Get 3 Free',
      bars: '6 Bars',
      duration: '180-Day Ritual',
      price: 99.99,
      currency: 'USD',
      symbol: '$',
      tag: 'BEST VALUE',
      is_hero: false,
      tax_inclusive: false,
      image: 'https://cdn.shopify.com/s/files/1/0801/3994/4187/files/1780818390Rapi-Bundles-Quatuor_Tp_300x300.png?v=1780818393',
    },
  ],
};

export const HERO = {
  image: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/p6xagjim_hf_20260303_220310_6aaacc7d-5934-464b-940a-e9bdd6ba4185-REPLACE.jpg.png',
  imageMobile: 'https://yoracare.com/cdn/shop/files/hf_20260303_220807_507e0978-a0af-4468-8f10-ff2fb2ec9c61.png?v=1772575795&width=1080',
  heading: 'Stop Watching Your Hair Disappear Down the Drain.',
  subheading: 'You are not losing hair. Your scalp is starving. K-Root is the 60-second Korean revival ritual that wakes up dormant follicles, halts daily shedding and grows back the density you thought was gone for good.',
  cta: 'Reclaim My Hair Now',
};

export const MARQUEE_ITEMS = [
  { icon: 'Headphones', label: 'Wakes Up Dead Follicles' },
  { icon: 'Sparkles', label: 'Stops Shedding in Weeks' },
  { icon: 'BadgeCheck', label: 'Backed by 12 Fermented Herbs' },
  { icon: 'Globe', label: 'Loved by 10,000+ Women Worldwide' },
];

export const STORY_BLOCKS = [
  {
    id: 's1',
    title: 'The Real Reason Your Hair Is Thinning',
    body: "It is not bad genes. It is not bad luck. It is a suffocated scalp — choked by years of silicone, sulfates and stress. Every strand you lose was a follicle that finally gave up trying to push through. K-Root strips that buildup in seconds and lets your scalp breathe again, the way Korean women have done for generations.",
  },
  {
    id: 's2',
    title: 'For the Stress That Hijacked Your Hair',
    body: 'Postpartum. Perimenopause. The job. The breakup. The endless brain fog. Your body whispered for help and your hair was the first thing it sacrificed. K-Root is built for exactly that scalp — inflamed, depleted, screaming under the surface. Twelve fermented Korean herbs flood the root, calm the burn and remind your follicles they still have a job to do.',
  },
  {
    id: 's3',
    title: '60 Seconds. No Routine. No Excuses.',
    body: "If it takes a 7-step routine and a dropper, you will quit by week two. We know because you already did. K-Root is one bar, one minute, in the shower you already take. Glide. Massage. Rinse. That is the entire ritual. The only thing harder than this is watching another year of hair leave you.",
  },
];

export const STORY_IMAGE = 'https://customer-assets.emergentagent.com/job_content-135/artifacts/wevpvpjj_hf_20260303_221345_12cf174b-4394-4f4d-9dd4-afd5eb2c910d-REPLACE.jpg.png';
export const STORY_IMAGE_2 = 'https://customer-assets.emergentagent.com/job_content-135/artifacts/3e1ewjou_hf_20260303_221718_f2badb06-52fc-4c66-9675-eb5e4ee5bc31-REPLACE.jpg.png';
export const MYSTERY_IMAGE = 'https://customer-assets.emergentagent.com/job_content-135/artifacts/kf9mto3g_hf_20260305_003409_75b91e88-6e02-44f1-9c8d-787e9b8d1b62-REPLACE.png';

export const QUOTE_REVIEW = {
  text: '"I stopped crying in the shower."',
  body: "Every wash for two years ended the same way — fistfuls of hair, the drain clogged, me sitting on the tile fighting tears. Three weeks with K-Root and the shedding cut in half. Eight weeks and my ponytail had weight in my hand again. This bar gave me back something I was sure I had lost forever.",
  author: 'Renata V., verified buyer',
};

export const TESTIMONIALS = [
  {
    id: 't1',
    image: 'https://yoracare.com/cdn/shop/files/hf_20260303_222204_8f36ce23-f42e-4a2a-8f2b-d363209d0164.png?v=1772576602&width=900',
    name: 'Camille D.',
    rating: 5,
    text: "I avoided ponytails for three years because the bald spot at my crown was impossible to hide. I tried biotin, peptide serums, even laser caps. Nothing. Six weeks into the K-Root ritual and the spot is closing in on itself. I wore my hair up to a wedding last weekend. I did not stop touching it all night.",
  },
  {
    id: 't2',
    image: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/fkuc3l70_4_5197fc80-7e88-413c-a9cd-c4fda84fac1a-REPLACE.jpg.png',
    name: 'Noor A.',
    rating: 5,
    text: "After my second baby my hair came out in clumps. Showers became a dread. My doctor said it would 'eventually stop'. Eventually was not coming. Within four weeks of using this bar the shedding cut in half. By month three my edges grew back. I take photos now because for a year I refused to.",
  },
  {
    id: 't3',
    image: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/vut71r6s_hf_20260303_223458_2de174d7-3c87-4ed9-ba93-dbc6d699d55b-REPLACE.jpg.png',
    name: 'Talia B.',
    rating: 5,
    text: "I am 41 and watched my part widen into a road. The mirror became the enemy. K-Root was honestly my last try before accepting hair pieces. Two months in and my part is a path again, not a highway. My partner noticed before I did. I cried — but the good kind this time.",
  },
];

export const HOME_FAQS = [
  {
    q: 'How fast will I actually see results?',
    a: "We will not lie to you to make a sale. Most women feel the difference in the first week — less itch, a lighter scalp, calmer roots. Shedding usually drops noticeably between days 18 and 28. Visible new baby hairs along the hairline and part typically show up in weeks 6–10. By week 12 you will be comparing photos and wondering why you waited so long. Your follicles run on a biological clock, not a marketing one — and K-Root works with it, every single day you use it.",
  },
  {
    q: 'Why is K-Root different from minoxidil, biotin and the serums I already tried?',
    a: "Everything you tried treats the symptom. K-Root treats the soil. Western hair products coat the strand or flood your bloodstream with vitamins your body cannot direct to the follicle. K-Root works exactly where the problem lives — the scalp itself. Twelve fermented Korean botanicals (ginseng, He Shou Wu, sophora, fermented Biota Orientalis) clear buildup, dial down inflammation and feed the follicle directly. No pills. No daily droppers. No three-month membership. One bar. One minute. Real biology.",
  },
  {
    q: 'Is it safe if my scalp is sensitive, postpartum or perimenopausal?',
    a: "Yes — and it was built specifically for you. Sulfate-free, paraben-free, silicone-free, fragrance-light, vegan, cruelty-free, pregnancy-safe and breastfeeding-safe. We deliberately formulated for the most reactive scalps because those are the ones suffering most. If you have an active scalp condition, a known allergy, or are under dermatological care, double-check the ingredient list (full list on the product page) or ask your derm first. Otherwise — you are clear to start tonight.",
  },
  {
    q: 'What if it does not work for me?',
    a: "You get every dollar back. We offer a 60-day full money-back guarantee — even on a bar that is half used. No customer service runaround, no restocking fee, no 'send us a video proof'. One email, one refund. We carry the risk so you can finally take the leap. If after 60 days K-Root did not slow your shedding or wake your scalp up, we honestly do not deserve your money.",
  },
  {
    q: 'How fast does it ship and where?',
    a: "Orders placed before 2pm ship the same business day. After that, next morning. Free shipping worldwide, no minimum, no hidden customs surprises — we cover it. Typical delivery: 6–9 business days in North America, EU and UK. You get a tracking link the moment it leaves our warehouse, and our team replies to emails within 12 hours, including weekends.",
  },
  {
    q: 'How is it made — and why a bar instead of a bottle?',
    a: "Liquid shampoo is 70–90% water. You are paying to ship water around the planet. A K-Root bar is 100% active formula — pressed in small batches using a Korean low-heat method that keeps the fermented herbs alive and bioavailable. Every batch is third-party tested for purity. The result: one tiny triangle does the work of three bottles, lasts up to 60 washes, and never plastics up your bathroom or your scalp.",
  },
];

export const PRODUCT_FAQS = [
  {
    q: 'Is it safe to use every day — even while pregnant or breastfeeding?',
    a: 'Yes. K-Root is 100% plant-derived, fragrance-light, sulfate-free, paraben-free, silicone-free, vegan and cruelty-free. No pharmaceuticals, no hormones, no synthetic stimulants. Safe to use daily during pregnancy, postpartum and breastfeeding — in fact, that is when most of our customers need it most.',
  },
  {
    q: 'How long does one bar last? Is it really cheaper than my shampoo?',
    a: "One K-Root bar = 40–60 washes ≈ 6–8 weeks of daily use. That is about $0.42 a wash — less than a sachet of conditioner. A 240ml bottle of premium shampoo runs out in 3 weeks and costs more. You are not paying more for a bar — you are stopping the slow bleed your bathroom shelf has been doing for years.",
  },
  {
    q: 'Can I keep using my current serums, oils and treatments?',
    a: 'Please do. K-Root is the missing first step, not a replacement. By stripping years of buildup and opening the follicle channel, every serum, peptide and oil you have been using will finally penetrate where it was supposed to all along. Most customers tell us their existing products suddenly start working again. K-Root unlocks the door — the rest of your routine walks through it.',
  },
  {
    q: 'Full ingredient list',
    a: 'Biota Orientalis Leaf Extract, Isatis Tinctoria Root Extract, Dendrobium Officinale Extract, Polygonum Multiflorum (He Shou Wu) Extract, Angelica Sinensis Extract, Ganoderma Atrum (Reishi) Extract, Sophora Flavescens Extract, Sesamum Indicum Seed Extract, Lycium Chinense Fruit Extract, Morus Alba Fruit Extract, Panax Ginseng Extract, Morus Alba Root Bark Extract, Vitex Trifolia Fruit Extract, Rosmarinus Officinalis Leaf Oil, Mentha Haplocalyx Extract, Cocos Nucifera Oil, Vitis Vinifera Seed Oil, Olea Europaea Fruit Oil, Butyrospermum Parkii (Shea) Butter, Simmondsia Chinensis Seed Oil, Macadamia Ternifolia Seed Oil, Caprylic/Capric Triglyceride, Zingiber Officinale Root Oil, Melaleuca Alternifolia Leaf Oil, Boswellia Carterii Oil, Cedrus Atlantica Bark Oil, Cymbopogon Citratus Leaf Oil, Butylene Glycol, Glycyrrhiza Uralensis Extract, Taraxacum Mongolicum Extract, Paris Polyphylla Chinensis Extract, Isatis Indigotica Extract.',
  },
  {
    q: 'Shipping, returns and the 60-day promise',
    a: 'Free worldwide shipping, always. Orders ship in 24 hours, arrive in 6–9 business days. Every order is protected by our 60-day money-back guarantee — even on a bar you have already started using. Hate it? One email, full refund. We do not play games with refunds because we are confident you will not need one.',
  },
];

export const PRODUCT_REVIEWS = [
  {
    id: 'r1',
    image: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/67m6e1lu_hf_20260305_002139_a7dd5799-ea2c-431e-aac9-0830b10124b6-REPLACE.jpg',
    name: 'Selene, 33',
    rating: 5,
    text: "I gave up on hair products two years ago. Rogaine made me itch, biotin gave me cystic acne, the $90 serums did nothing but stain my pillow. K-Root felt like a long shot. Six weeks in and my drain is half as full as it was. Baby hairs along the temples like a halo. My husband caught me running my fingers through it in the mirror and just smiled.",
  },
  {
    id: 'r2',
    image: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/6lij6zmo_hf_20260305_002740_f316d5b0-ba4d-439b-b066-eeed483a0f5c-REPLACE.jpg',
    name: 'Marisol, 36',
    rating: 5,
    text: 'My OB shrugged when I asked about postpartum shedding — said wait it out. I waited nine months and lost a third of my hair. K-Root was the only thing that did not feel like another empty promise. My part stopped widening at week three. My ponytail has weight in my hand again. I am not waiting it out anymore. I am taking it back.',
  },
  {
    id: 'r3',
    image: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/b373o65r_hf_20260305_002904_4623e8f6-469c-4f33-a433-ad86a35d3ecb-REPLACE.jpg',
    name: 'Iyanna, 28',
    rating: 5,
    text: "I assumed shampoo bars were for hippies and TikTok. Then I saw the science: 12 fermented Korean herbs, no water filler, direct scalp contact. From the first wash my scalp felt different — lighter, cleaner, awake. Ten weeks in and my stylist asked what changed. I just smiled and showed her the bar.",
  },
];

export const HOW_IT_WORKS = [
  {
    id: 'h1',
    image: 'https://yoracare.com/cdn/shop/files/hf_20260305_003716_8193b858-c5ed-4969-90b3-e2d974182020.webp?v=1772908356&width=1200',
    title: 'Glide directly on the scalp',
    body: 'Wet hair. Part it in two sections. Run the triangle bar right where the roots live — no hand-foam needed.',
  },
  {
    id: 'h2',
    image: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/pxmpcien_hf_20260305_004006_4e56da85-ff5b-4822-a618-72c716cb9535-REPLACE.jpg.png',
    title: 'Massage 60 seconds. Feel the tingle.',
    body: "Twelve fermented herbs flood the follicle. The cool tingle is rosemary and ginger waking the scalp up — that is the protocol working.",
  },
  {
    id: 'h3',
    image: 'https://yoracare.com/cdn/shop/files/hf_20260305_004133_751532ac-9d6a-479a-a3f2-11312f32feff.webp?v=1772908386&width=1200',
    title: 'Rinse. Repeat. Watch it fill in.',
    body: 'Less in the drain by week 3. New baby hairs by week 6. A part you do not have to hide by week 10. Real biology, on schedule.',
  },
];

export const PRODUCT_VIDEOS = [
  {
    id: 'v1',
    src: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/j0ncx6qo_creative%20%281%29.mp4',
    poster: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/db9dytor_K-Root_logo_diagonal.png',
  },
  {
    id: 'v2',
    src: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/ira7em57_creative%20%282%29.mp4',
    poster: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/db9dytor_K-Root_logo_diagonal.png',
  },
  {
    id: 'v3',
    src: 'https://yoracare.com/cdn/shop/videos/c/vp/1ef2930e064c419392152b58464d94c9/1ef2930e064c419392152b58464d94c9.HD-1080p-3.3Mbps-77436190.mp4?v=0',
    poster: 'https://yoracare.com/cdn/shop/files/preview_images/1ef2930e064c419392152b58464d94c9.thumbnail.0000000000_300x300.jpg?v=1773006532',
  },
];

export const LOOX_REVIEWS = [
  {
    id: 'lx1',
    type: 'video',
    media: 'https://yoracare.com/cdn/shop/videos/c/vp/6103ef67550f403fa181c616f3780a4f/6103ef67550f403fa181c616f3780a4f.HD-1080p-3.3Mbps-77436189.mp4?v=0',
    poster: 'https://images.loox.io/uploads/2026/5/20/WIqHsbZ-W_UrTk_kMCv_orig.jpg',
    name: 'Yuna L.',
    verified: true,
    rating: 5,
    text: 'I have never felt my scalp this awake. Three washes in and the difference is impossible to ignore.',
    highlights: ['I have never felt my scalp this awake'],
  },
  {
    id: 'lx2',
    type: 'image',
    media: 'https://images.loox.io/uploads/2026/3/6/vJ2xvHpg79.jpg',
    name: 'Renata V.',
    verified: true,
    rating: 5,
    text: 'The triangle shape is genius — it gets into the parts no pad of fingers ever could. One month in and my crown has visible new fluff.',
    highlights: ['my crown has visible new fluff'],
  },
  {
    id: 'lx3',
    type: 'image',
    media: 'https://images.loox.io/uploads/2026/3/6/Jqf_efBq3v.jpg',
    name: 'Petra M.',
    verified: true,
    rating: 5,
    text: 'I have wasted four figures on serums that did nothing. One wash with this bar and my scalp finally felt like skin again instead of a dry sponge.',
    highlights: ['my scalp finally felt like skin again'],
  },
  {
    id: 'lx4',
    type: 'image',
    media: 'https://images.loox.io/uploads/2026/3/6/_UjC9axn_Q.jpg',
    name: 'Aurelia B.',
    verified: true,
    rating: 5,
    text: 'I left Nioxin after eight years for this. The difference is not subtle. My scalp feels actually clean for the first time, not just stripped.',
    highlights: ['My scalp feels actually clean for the first time'],
  },
  {
    id: 'lx5',
    type: 'image',
    media: 'https://images.loox.io/uploads/2026/3/6/7ICaPLR43l.jpg',
    name: 'Linnea J.',
    verified: true,
    rating: 5,
    text: "Three weeks. Baby hairs along my temples. Twenty-one days that have done what two years of $90 serums could not. I am furious it took me this long to find it.",
    highlights: ['Baby hairs along my temples'],
  },
  {
    id: 'lx6',
    type: 'text',
    name: 'Daria K.',
    verified: true,
    rating: 5,
    text: "Postpartum shedding nearly broke me. Five weeks of K-Root and my stylist stopped me mid-cut to ask what I was doing differently. That moment was worth every penny.",
    highlights: ['my stylist stopped me mid-cut to ask what I was doing differently'],
  },
  {
    id: 'lx7',
    type: 'image',
    media: 'https://images.loox.io/uploads/2026/3/6/jjMX76Tjoj.jpg',
    name: 'Magnolia R.',
    verified: true,
    rating: 5,
    text: "I used to take a deep breath before every wash because I knew what the drain would look like. Two bars in and that fear is gone. I enjoy showering again.",
    highlights: ['I enjoy showering again'],
  },
  {
    id: 'lx8',
    type: 'image',
    media: 'https://images.loox.io/uploads/2026/3/6/yvs0nfutFY.jpg',
    name: 'Cassia P.',
    verified: true,
    rating: 5,
    text: "My partner said 'your hair looks different — heavier' before I had said a word. Week six. I cried in front of him for the first time in a happy way.",
    highlights: ['your hair looks different — heavier'],
  },
  {
    id: 'lx9',
    type: 'image',
    media: 'https://images.loox.io/uploads/2026/3/6/QycIExiO4l.jpg',
    name: 'Elinor S.',
    verified: true,
    rating: 5,
    text: 'Six weeks and my colorist asked me which clinic I went to. I told her none — I rubbed a green triangle on my head every morning. Her face was priceless.',
    highlights: ['my colorist asked me which clinic I went to'],
  },
  {
    id: 'lx10',
    type: 'text',
    name: 'Roxane H.',
    verified: false,
    rating: 5,
    text: 'Type 3 curls, low porosity, almost a month in. Honestly the missing brick in my whole routine. Every product I already owned is finally doing its job because the buildup is gone. Areas at my temples I gave up on are showing baby hair again.',
    highlights: ['the missing brick in my whole routine', 'baby hair again'],
  },
  {
    id: 'lx11',
    type: 'text',
    name: 'Tahlia M.',
    verified: false,
    rating: 5,
    text: "Two washes and my hair literally felt awake. Lighter at the root, more bounce, less itch by the afternoon. I cannot go back. Sending photos as soon as week 4 hits.",
    highlights: ['my hair literally felt awake'],
  },
  {
    id: 'lx12',
    type: 'text',
    name: 'Beatriz L.',
    verified: true,
    rating: 5,
    text: 'I love the bar and the scrubber together. Noticeably less hair on my pillow after only two weeks. The scent is light and clean — not perfume-y. Just thank you.',
    highlights: ['Noticeably less hair on my pillow after only two weeks'],
  },
  { id: 'lx13', type: 'text', name: 'Hadley N.', verified: true, rating: 5, text: 'I used to spend twenty minutes hiding the thin patch with strategic parts. Now I leave the house in five and forget it is even there.', highlights: ['Now I leave the house in five'] },
  { id: 'lx14', type: 'text', name: 'Saoirse G.', verified: true, rating: 5, text: 'Gifted bars to three friends. All three texted within a month begging for the link. That has never happened with any other product I have recommended.', highlights: ['begging for the link'] },
  { id: 'lx15', type: 'text', name: 'Marlowe E.', verified: true, rating: 5, text: 'Three weeks and the constant scalp itch I had ignored for years is just gone. If the regrowth comes too I will buy this for the rest of my life.', highlights: ['the constant scalp itch I had ignored for years is just gone'] },
  { id: 'lx16', type: 'text', name: 'Tessa V.', verified: true, rating: 5, text: 'The triangle shape looked gimmicky in the photos. Five seconds in the shower and you realize it was engineered, not styled. Slides between sections like a key.', highlights: ['engineered, not styled'] },
  { id: 'lx17', type: 'text', name: 'Junia O.', verified: true, rating: 5, text: 'I stopped dying my hair after the damage hit a tipping point. This bar gave the strands I still had room to come back. My natural color is filling in stronger than before.', highlights: ['the strands I still had room to come back'] },
  { id: 'lx18', type: 'text', name: 'Anaya R.', verified: true, rating: 4, text: 'My ponytail used to be a sad rubber-banded wisp. It is now a real handful. I keep grabbing it just to confirm I am not dreaming.', highlights: ['I am not dreaming'] },
  { id: 'lx19', type: 'text', name: 'Lorenza H.', verified: true, rating: 5, text: 'I did not realize how much gunk lived on my scalp until the first wash with K-Root. The squeak of clean was startling. I get it now.', highlights: ['The squeak of clean was startling'] },
  { id: 'lx20', type: 'text', name: 'Maeve C.', verified: true, rating: 4, text: 'My mom blamed her thin hair on genes for forty years. She has been using mine for a month and even she says it feels different. Genes did not need fixing — her scalp did.', highlights: ['her scalp did'] },
  { id: 'lx21', type: 'text', name: 'Solenne T.', verified: true, rating: 5, text: 'A year of biotin gave me nothing but breakouts. Six weeks of this bar did more visible work than that entire pill bottle. Sold for life.', highlights: ['six weeks of this bar did more visible work'] },
  { id: 'lx22', type: 'text', name: 'Yuki F.', verified: true, rating: 5, text: 'The lather is creamy, not stripping. My hair does not tangle into a wet rope at the end of a wash anymore. That alone earned the price tag.', highlights: ['My hair does not tangle into a wet rope'] },
  { id: 'lx23', type: 'text', name: 'Brielle U.', verified: true, rating: 4, text: 'I chase every viral hair trend on TikTok and abandon them by week two. K-Root is the only one I have already repurchased — twice.', highlights: ['the only one I have already repurchased'] },
  { id: 'lx24', type: 'text', name: 'Esme W.', verified: true, rating: 5, text: 'I will not promise miracles, but four weeks in my hair is visibly thicker. I feel the extra weight when I tie it up. That is data, not a feeling.', highlights: ['visibly thicker', 'That is data, not a feeling'] },
  { id: 'lx25', type: 'text', name: 'Octavia D.', verified: true, rating: 5, text: 'I assumed shampoo bars meant scratchy hippie texture. K-Root feels luxurious — like dessert for the scalp. I was wrong and I am happy about it.', highlights: ['like dessert for the scalp'] },
  { id: 'lx26', type: 'text', name: 'Marigold P.', verified: true, rating: 5, text: 'Month one I was hopeful. Month two I was sure. This is the only thing I changed in my routine — and the part is closing.', highlights: ['the part is closing'] },
  { id: 'lx27', type: 'text', name: 'Calliope Z.', verified: true, rating: 4, text: 'Wash day used to be the day I dreaded most of the week. Now I almost look forward to it. I see the progress with my own eyes every Sunday.', highlights: ['I almost look forward to it'] },
  { id: 'lx28', type: 'text', name: 'Anika S.', verified: true, rating: 5, text: 'I thought K-beauty was glass skin and ten serums. Apparently they have been winning the scalp game for centuries too. I am in.', highlights: ['winning the scalp game for centuries'] },
  { id: 'lx29', type: 'text', name: 'Mireille X.', verified: true, rating: 3, text: 'Minoxidil made my shedding worse for six months before improving. K-Root went the other direction immediately — slow, steady, every week gaining ground.', highlights: ['every week gaining ground'] },
  { id: 'lx30', type: 'text', name: 'Halsey B.', verified: true, rating: 5, text: 'My thinning started after my divorce. Losing my hair on top of losing the life I knew broke something in me. This is the first product that handed any of it back.', highlights: ['the first product that handed any of it back'] },
  { id: 'lx31', type: 'text', name: 'Vivienne K.', verified: true, rating: 5, text: 'One bar replaced three products in my routine. Less clutter under the sink and the results are better. The math is brutally simple.', highlights: ['One bar replaced three products'] },
  { id: 'lx32', type: 'text', name: 'Nia E.', verified: true, rating: 5, text: 'I bought it for growth and stayed for the scalp feel. The difference between K-Root and regular shampoo is the difference between brushing your teeth and actually flossing.', highlights: ['the difference between brushing your teeth and actually flossing'] },
  { id: 'lx33', type: 'text', name: 'Aurelia G.', verified: true, rating: 5, text: 'I showed my before-and-after to a coworker at lunch. She ordered her bar before we left the cafe. The photos do the selling for me.', highlights: ['The photos do the selling for me'] },
  { id: 'lx34', type: 'text', name: 'Romi J.', verified: true, rating: 5, text: 'My scalp used to ache by 4pm and I thought that was normal. Three weeks of K-Root and I forgot scalps were even capable of feeling tense. Comfort is the new baseline.', highlights: ['Comfort is the new baseline'] },
  { id: 'lx35', type: 'text', name: 'Indira P.', verified: true, rating: 5, text: 'I told my dermatologist about the bar. She wrote the brand name on her prescription pad and asked her assistant to look it up. That is not a typical reaction.', highlights: ['She wrote the brand name on her prescription pad'] },
  { id: 'lx36', type: 'text', name: 'Astrid V.', verified: true, rating: 5, text: 'I keep running my fingers through my hair just because I can. It feels thick again — and I had forgotten what thick felt like.', highlights: ['I had forgotten what thick felt like'] },
  { id: 'lx37', type: 'text', name: 'Coralie M.', verified: true, rating: 5, text: 'Threw my Nioxin in the bin a month ago and I have not regretted it for a second. K-Root is better in every measurable category and costs less per wash. No comparison.', highlights: ['better in every measurable category'] },
  { id: 'lx38', type: 'text', name: 'Saskia F.', verified: true, rating: 5, text: 'Postpartum shedding had me sobbing at every wash. Six weeks of K-Root and I finally recognize myself in photos again. That is not a small thing.', highlights: ['I finally recognize myself in photos again'] },
  { id: 'lx39', type: 'text', name: 'Larkin O.', verified: true, rating: 5, text: 'I avoided pool trips for two years because wet hair revealed every thin spot. I leave for Greece next month and I am not anxious. That alone is worth ten bars.', highlights: ['I am not anxious'] },
  { id: 'lx40', type: 'text', name: 'Imani D.', verified: true, rating: 5, text: 'I wear protective braid styles and was terrified of traction alopecia. My edges are filling in steadily. My braider noticed before I said a word.', highlights: ['My edges are filling in'] },
  { id: 'lx41', type: 'text', name: 'Margaux H.', verified: true, rating: 5, text: 'Tiny baby hairs along my temples after two flat years of nothing working. I want to scream into a pillow. The happy kind of scream.', highlights: ['Tiny baby hairs along my temples'] },
  { id: 'lx42', type: 'text', name: 'Quintessa R.', verified: true, rating: 5, text: 'I tried every TikTok hair hack — rice water, vinegar rinse, mask of the week. This is the only one that worked and did not destroy the bathroom.', highlights: ['the only one that worked'] },
];

export const GALLERY_HERO_VIDEO = {
  src: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/o6luh4ew_creative.mp4',
  poster: 'https://customer-assets.emergentagent.com/job_content-135/artifacts/db9dytor_K-Root_logo_diagonal.png',
};

export const STATS = [
  { value: '89%', label: 'Saw visibly less hair in the drain by week 4' },
  { value: '94%', label: 'Said their scalp felt healthier and lighter' },
  { value: "9 / 10", label: 'Would never go back to bottled shampoo' },
];
